/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var searchQuery = require("../searchquery");
var disposeObject = require("../util/disposable").disposeObject;
var stringUtil = require("../util/string");

var shared = require("./shared");

//-------------------------------------------
// Retrieves default value (phrase) for particular property,
// specified via [template data].defaultValue or [*AdvancedSearchItem].prototype.defaultValue.
// Returns empty string if neither specified of above was defined.
var getDefaultPhrase = shared.createDefaultValueResolverFunction("", "defaultValue", "viewModel.prototype.defaultValue");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// AdvancedSearchItem view-model
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// Initializes the view-model for a new
// advanced search item.  Essentially a key (property)
// value (phrase) pair.
function AdvancedSearchItemViewModel(owner, property, phrase, not, hasFocus) {
    if (!(this instanceof AdvancedSearchItemViewModel)) { return new AdvancedSearchItemViewModel(owner, property, phrase, not, hasFocus); } // if new was not used, force it now

    // the advancedSearchViewModel used to resolve the type from a property name.
    if (owner && typeof owner.lookupPropertyType !== "function") { throw new Error("owner.propertyLookup must be a function"); }

    // normalize parameters
    not = !!not;
    property = (typeof property === "string") ? property : "";
    // Use default if and only if input phrase is undefined (not specified),
    // otherwise we might override user's input.
    var template = owner.lookupPropertyType(property);
    phrase = (phrase === undefined)
        ? getDefaultPhrase(template)
        : (typeof phrase === "string") ? phrase : "";

    // state
    this.not = ko.observable(not);
    this.property = ko.observable(property);
    this.phrase = ko.observable(phrase);

    // initialize
    this.extras = function advancedSearchItemExtras() { return; };
    this.extras.owner = owner;
    this.extras.template = ko.observable(this._loadViewModel(template));
    this.extras.hasFocus = ko.observable(!!hasFocus);

    // subscriptions
    this._propertySubscription = this.property.subscribe(this._propertyChanged, this);
    this._phraseSubscription = this.phrase.subscribe(this._phraseChanged, this);
    this._notSubscription = this.not.subscribe(this._phraseChanged, this);
    this._templateComputed = ko.computed(this._templateViewModelChanged, this);
}


//-------------------------------------------
// Disposes of the current view-model item.
AdvancedSearchItemViewModel.prototype.dispose = function advancedSearchItemViewModelDispose() {
    this._templateComputed.dispose();
    this._notSubscription.dispose();
    this._phraseSubscription.dispose();
    this._propertySubscription.dispose();
    disposeObject(this.extras.template(), true);
};


//-------------------------------------------
// Converts the advanced search item to a search query
AdvancedSearchItemViewModel.prototype.toSearchQuery = function advancedSearchItemViewModelToSearchQuery() {
    var property = this.property(),
        phrase = this.phrase(),
        not = this.not();
    if (stringUtil.isNullOrWhitespace(phrase)) { return null; }
    var query = stringUtil.isNullOrWhitespace(property)
        ? searchQuery.buildPhrase(phrase)
        : searchQuery.buildProperty(property, phrase);
    return (not ? searchQuery.buildBinary("not", query) : query);
};


//-------------------------------------------
AdvancedSearchItemViewModel.prototype._loadViewModel = function advancedSearchItemViewModelLoadViewModel(template) {
    var viewModel = template.viewModel(template.data);
    viewModel.load(this.phrase.peek(), this.not.peek());
    return { name: template.viewModel.prototype.templateId, data: viewModel };
};


//-------------------------------------------
// Update `template` if `property` and resolved
// template have changed.
AdvancedSearchItemViewModel.prototype._propertyChanged = shared.createInternalUpdateGuard(
    function advancedSearchItemViewModelPropertyChanged(value) {
        var template = this.extras.owner.lookupPropertyType(value);
        this.phrase(getDefaultPhrase(template));
        this.extras.template(this._loadViewModel(template));
    }
);


//-------------------------------------------
// Reloads the `templateViewModel` if either the
// `phrase` or `not` observables have changed.
AdvancedSearchItemViewModel.prototype._phraseChanged = shared.createInternalUpdateGuard(
    function advancedSearchItemViewModelPhraseChanged() {
        var phrase = this.phrase.peek(),
            not = this.not.peek(),
            viewModel = this.extras.template();
        viewModel = viewModel && viewModel.data;
        if (viewModel && typeof viewModel.load === "function") { viewModel.load(phrase, not); }
    }
);


//-------------------------------------------
// Updates the phrase and not when any changes
// are made to the `templateViewModel`.
AdvancedSearchItemViewModel.prototype._templateViewModelChanged = shared.createInternalSubscription(
    "extras.template",
    shared.createInternalUpdateGuard(
        function advancedSearchItemViewModelTemplateViewModelChanged() {
            var viewModel = this.extras.template();
            viewModel = viewModel && viewModel.data;
            if (viewModel && typeof viewModel.save === "function") {
                var result = viewModel.save(), phrase = result[0];
                this.phrase(typeof phrase === "string" ? phrase : "");
                this.not(!!result[1]);
            }
        }
    )
);


module.exports = AdvancedSearchItemViewModel;




//////////////////
// WEBPACK FOOTER
// ./~/pli/advancedsearch/advancedSearchItemViewModel.js
// module id = 456
// module chunks = 49